import {
  LegacyCard,
  ContextualSaveBar,
  Layout,
  Loading,
  SkeletonBodyText,
  SkeletonDisplayText,
  SkeletonPage,
  TextContainer,
  Toast,
} from "@shopify/polaris";

import { useState, useCallback, useRef, useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { readUser } from "../../services/localStorage.service";

import MainContainer from "../MainContainer";
import classNames from "classnames";

function MainLayout() {
  const location = useLocation();

  const defaultState = useRef({
    emailFieldValue: "dharma@jadedpixel.com",
    nameFieldValue: "Jaded Pixel",
  });
  // const skipToContentRef = useRef<HTMLAnchorElement>(null);

  const [toastActive, setToastActive] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isDirty, setIsDirty] = useState(false);
  // const [searchActive, setSearchActive] = useState(false);
  // const [searchValue, setSearchValue] = useState("");
  // const [userMenuActive, setUserMenuActive] = useState(false);
  // const [mobileNavigationActive, setMobileNavigationActive] = useState(false);
  // const [modalActive, setModalActive] = useState(false);
 
   
  const [nameFieldValue, setNameFieldValue] = useState(
    defaultState.current.nameFieldValue
  );
  const [emailFieldValue, setEmailFieldValue] = useState(
    defaultState.current.emailFieldValue
  );
  // const [storeName, setStoreName] = useState(
  //   defaultState.current.nameFieldValue
  // );
  // const [supportSubject, setSupportSubject] = useState("");
  // const [supportMessage, setSupportMessage] = useState("");
  // const [userDetails, setUserDetails]: any = useState();

  // const handleSubjectChange = useCallback(
  //   (value: string) => setSupportSubject(value),
  //   []
  // );
  // const handleMessageChange = useCallback(
  //   (value: string) => setSupportMessage(value),
  //   []
  // );
  const handleDiscard = useCallback(() => {
    setEmailFieldValue(defaultState.current.emailFieldValue);
    setNameFieldValue(defaultState.current.nameFieldValue);
    setIsDirty(false);
  }, []);
  const handleSave = useCallback(() => {
    defaultState.current.nameFieldValue = nameFieldValue;
    defaultState.current.emailFieldValue = emailFieldValue;

    setIsDirty(false);
    setToastActive(true);
    // setStoreName(defaultState.current.nameFieldValue);
  }, [emailFieldValue, nameFieldValue]);
  // const handleNameFieldChange = useCallback((value: string) => {
  //   setNameFieldValue(value);
  //   value && setIsDirty(true);
  // }, []);
  // const handleEmailFieldChange = useCallback((value: string) => {
  //   setEmailFieldValue(value);
  //   value && setIsDirty(true);
  // }, []);
  // const handleSearchResultsDismiss = useCallback(() => {
  //   setSearchActive(false);
  //   setSearchValue("");
  // }, []);
  // const handleSearchFieldChange = useCallback((value: string) => {
  //   setSearchValue(value);
  //   setSearchActive(value.length > 0);
  // }, []);
  const toggleToastActive = useCallback(
    () => setToastActive((toastActive) => !toastActive),
    []
  );
  // const toggleUserMenuActive = useCallback(
  //   () => setUserMenuActive((userMenuActive) => !userMenuActive),
  //   []
  // );
  // const toggleMobileNavigationActive = useCallback(
  //   () =>
  //     setMobileNavigationActive(
  //       (mobileNavigationActive) => !mobileNavigationActive
  //     ),
  //   []
  // );
  // const toggleIsLoading = useCallback(
  //   () => setIsLoading((isLoading) => !isLoading),
  //   []
  // );
  // const toggleModalActive = useCallback(
  //   () => setModalActive((modalActive) => !modalActive),
  //   []
  // );

  useEffect(() => {
    const UserDetails = readUser();
    // UserDetails && setUserDetails(UserDetails);
  }, []);

  const toastMarkup = toastActive ? (
    <Toast onDismiss={toggleToastActive} content="Changes saved" />
  ) : null;

  // const userMenuActions = [
  //   {
  //     items: [{ content: "Logout", icon: ArrowRightMinor, url: "/logout" }],
  //   },
  // ];

  const contextualSaveBarMarkup = isDirty ? (
    <ContextualSaveBar
      message="Unsaved changes"
      saveAction={{
        onAction: handleSave,
      }}
      discardAction={{
        onAction: handleDiscard,
      }}
    />
  ) : null;

  // const userMenuMarkup = (
  //   <TopBar.UserMenu
  //     actions={userMenuActions}
  //     name={userDetails?.firstName}
  //     detail={`${userDetails?.firstName} ${userDetails?.lastName}`}
  //     initials={userDetails?.firstName.charAt(0)}
  //     open={userMenuActive}
  //     onToggle={toggleUserMenuActive}
  //   />
  // );

  // const searchResultsMarkup = (
  //   <ActionList
  //     items={[
  //       { content: "Shopify help center" },
  //       { content: "Community forums" },
  //     ]}
  //   />
  // );

  // const searchFieldMarkup = (
  //   <TopBar.SearchField
  //     onChange={handleSearchFieldChange}
  //     value={searchValue}
  //     placeholder="Search"
  //   />
  // );

  // const topBarMarkup = (
  //   <TopBar
  //     showNavigationToggle
  //     userMenu={userMenuMarkup}
  //     searchResultsVisible={searchActive}
  //     onSearchResultsDismiss={handleSearchResultsDismiss}
  //     onNavigationToggle={toggleMobileNavigationActive}
  //   />
  // );

  // const navigationMarkup = (
  //   <Navigation location="/">
  //     <Navigation.Section
  //       items={[
  //         {
  //           url: "/designs",
  //           label: "Designs",
  //           icon: HomeMinor,
  //         },
  //         {
  //           url: "/products",
  //           label: "Products",
  //           excludePaths: ["#"],
  //           icon: ProductsMinor,
  //         },
  //         {
  //           url: "/customers",
  //           label: "Customers",
  //           excludePaths: ["#"],
  //           icon: CustomersMajor,
  //         },

  //         {
  //           url: "/print-methods",
  //           label: "Print Methods",
  //           excludePaths: ["#"],
  //           icon: HomeMinor,
  //         },
  //         // {
  //         //   url: "#",
  //         //   excludePaths: ["#"],
  //         //   label: "Design",
  //         //   icon: OrdersMinor,
  //         //   badge: "15",
  //         // },
  //       ]}
  //     />
  //     <Navigation.Section
  //       separator
  //       title="E-Commerce Integration"
  //       items={[
  //         {
  //           label: "Shopify",
  //           icon: HomeMajor,
  //           onClick: toggleIsLoading,
  //           url: "/integration",
  //         },
  //       ]}
  //       action={{
  //         icon: ConversationMinor,
  //         accessibilityLabel: "Contact support",
  //         onClick: toggleModalActive,
  //       }}
  //     />
  //   </Navigation>
  // );

  const loadingMarkup = isLoading ? <Loading /> : null;

  // const actualPageMarkup = (
  //   <Page title="Account">
  //     <Layout>
  //       <Layout.AnnotatedSection
  //         title="Account details"
  //         description="Jaded Pixel will use this as your account information."
  //       >
  //         <LegacyCard sectioned>
  //           <FormLayout>
  //             <TextField
  //               label="Full name"
  //               value={nameFieldValue}
  //               onChange={handleNameFieldChange}
  //               autoComplete="name"
  //             />
  //             <TextField
  //               type="email"
  //               label="Email"
  //               value={emailFieldValue}
  //               onChange={handleEmailFieldChange}
  //               autoComplete="email"
  //             />
  //           </FormLayout>
  //         </LegacyCard>
  //       </Layout.AnnotatedSection>
  //     </Layout>
  //   </Page>
  // );

  const loadingPageMarkup = (
    <SkeletonPage>
      <Layout>
        <Layout.Section>
          <LegacyCard sectioned>
            <TextContainer>
              <SkeletonDisplayText size="small" />
              <SkeletonBodyText lines={9} />
            </TextContainer>
          </LegacyCard>
        </Layout.Section>
      </Layout>
    </SkeletonPage>
  );

  const pageMarkup = isLoading ? loadingPageMarkup : <Outlet></Outlet>;

  // const logo = {
  //   width: 124,
  //   topBarSource: "/logo.png",
  //   contextualSaveBarSource: "/logo.png",
  //   url: "#",
  //   accessibilityLabel: "Kodiak",
  // };

  const widePage =
    location.pathname.startsWith("/product-catalog") ||
    location.pathname.startsWith("/orders/");

  return (
    // <div style={{ height: "500px" }} className="main-container">
    //   <Frame
    //     // logo={logo}
    //     // topBar={<div>123</div>}
    //     // navigation={<div>345</div>}
    //     showMobileNavigation={mobileNavigationActive}
    //     onNavigationDismiss={toggleMobileNavigationActive}
    //     skipToContentTarget={skipToContentRef}
    //   >
    //   </Frame>
    // </div>
    <div className="App">
      <MainContainer
        className={classNames({
          "max-w-[1180px]": !widePage,
          "max-w-[1400px]": widePage,
        })}
      >
        {contextualSaveBarMarkup}
        {loadingMarkup}
        {pageMarkup}
        {toastMarkup}
      </MainContainer>
    </div>
  );
}

export default MainLayout;
